import * as React from "react";

// Top-view floor lamp with light glow
function LampIcon({ color = "#FFC107", width = 40, height = 40, name }) {
  return (
    <div style={{ textAlign: "center" }}>
      {name && <p style={{ margin: 0, fontSize: "10px", userSelect: "none" }}>{name}</p>}
      <svg
        viewBox="0 0 100 100"
        height={height}
        width={width}
      >
        {/* Light glow */}
        <circle cx="50" cy="50" r="45" fill={color} opacity="0.2" />
        <circle cx="50" cy="50" r="35" fill={color} opacity="0.3" />
        <circle cx="50" cy="50" r="25" fill={color} opacity="0.4" />
        {/* Lamp shade - top view */}
        <circle cx="50" cy="50" r="18" fill="#37474F" />
        <circle cx="50" cy="50" r="14" fill="#455A64" />
        {/* Light bulb center */}
        <circle cx="50" cy="50" r="8" fill={color} />
        <circle cx="50" cy="50" r="4" fill="#FFECB3" />
      </svg>
    </div>
  );
}

export default LampIcon;
